import React, { Component } from 'react';
import axios from 'axios';
import { Form, Button, Modal } from 'react-bootstrap';
import StartEndDate from '../components/startEndDate/StartEndDate';
import ReportType from '../components/reportType/ReportType';
import config from '../../config/config';
import { momentToISOString } from '../../utils/dateUtils'
import ProgressBar from '../components/progressBar/ProgressBar';

const FileDownload = require('react-file-download');

const appUrlPath = `/${config.appUrlPath}`;

export class MonitoringReport extends Component {

  constructor(props) {
    super(props);
    this.state = {
      redirect: false,
      isLoading: false,
      startDate: null,
      endDate: null,
      reportType: 'quotation',
      showModal: false,
      message: ''
    };
    this.handleChangeStartDate = this.handleChangeStartDate.bind(this);
    this.handleChangeEndDate = this.handleChangeEndDate.bind(this);
    this.handleChangeReportType = this.handleChangeReportType.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.close = this.close.bind(this);

    axios.get(`${appUrlPath}/getCsrfToken`, {
      params: {},
      headers: { 'ACTION-LOG': 'Access Monitoring Report Page' }
    })
    .then((res) => {
      axios.defaults.headers.common = {
        'CSRF-TOKEN': res.data.csrfToken
      };
    })
    .catch(() => {
    });
  }

  handleChangeStartDate(date) {
    if (date) {
      this.setState({
        startDate: momentToISOString(date)
      });
    }
  }

  handleChangeEndDate(date) {
    if (date) {
      this.setState({
        endDate: momentToISOString(date)
      });
    }
  }

  handleChangeReportType(e) {
    this.setState({
      reportType: e.target.value
    });
  }

  handleClick() {
    window.location.assign('/en/motorb2b/home');
  }

  handleSubmit(event) {
    event.preventDefault();
    // validation
    const startDate = this.state.startDate;
    const endDate = this.state.endDate;
    if (!startDate || !endDate) {
      this.setState({
        message: 'The start date or end date cannot be null.',
        showModal: true
      });
      return;
    }
    this.setState({ isLoading: true })
    axios.post(`${appUrlPath}/generateMonReport`, {
      startDate: this.state.startDate,
      endDate: this.state.endDate,
      reportType: this.state.reportType
    }, { responseType: 'arraybuffer' })
    .then((response) => {
      this.setState({ isLoading: false })
      FileDownload(response.data, 'report.xlsx');
    })
    .catch((error) => {
      let errorMsg = '';
      if (error.response) {
        errorMsg = error.response.data; 
      }
      this.setState({
        message: errorMsg || 'Generate Fail.',
        showModal: true,
        isLoading: false
      });
    });
  }

  close() {
    this.setState({ showModal: false });
  }

  render() {
    if (this.state.isLoading) {
      return (
        <ProgressBar />
      )
    }

    return (
      <div>
        {this.state.showModal ?
        <Modal.Dialog>
          <Modal.Header>
            <Modal.Title>Message</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.message}
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={this.close}>OK</Button>
          </Modal.Footer>
        </Modal.Dialog> : null}
        <h2 className="ebaoUtil__HeaderTwo">Monitoring Report</h2>
        <h3 className="ebaoUtil__HeaderThree">Reporting Condition</h3>
        <Form onSubmit={this.handleSubmit}>
            <div className="ebaoUtil__Form-80">
               <StartEndDate
                  startDate={this.state.startDate}
                  endDate={this.state.endDate}
                  startDateLabel="Start Date*"
                  endDateLabel="End Date*"
                  handleChangeStartDate={this.handleChangeStartDate}
                  handleChangeEndDate={this.handleChangeEndDate}
               />
               <ReportType handleChangeReportType={this.handleChangeReportType} defaultReportType={this.state.reportType} />
               <div className="ebaoUtil__Row">
                 <div className="ebaoUtil__ButtonGroup">
                   <button type="submit" className="btn btn-axa">Generate Report</button>{' '}
                   <button type="button" className="btn btn-axa" onClick={this.handleClick}>Exit</button>
                 </div>
               </div>
            </div>
         </Form>
      </div>
    )
  }
}

export default MonitoringReport;



// WEBPACK FOOTER //
// ./src/app/pages/MonitoringReport.js